import React from 'react';
import { getColorFromScheme } from '../../helpers/utils';

export default function Header({ colorScheme, borderType, children }) {
  // success: border-emerald-200 bg-emerald-100
  // warning: border-orange-200 bg-orange-100
  // error: border-red-200 bg-red-100
  // neutral: border-gray-200 bg-gray-100
  const color = getColorFromScheme(colorScheme)

  // default to border-state-100
  const bgColor = color === 'gray' ? 'slate' : color

  // border-solid | border-dashed | border-dotted
  borderType = borderType || 'dashed';

  return (
    <div className={`p-4 border-3 border-${borderType} border-${color}-200 bg-${bgColor}-100 md:rounded-lg md:my-2`}>
      {children}
    </div>
  );
}
